export default "__VITE_ASSET__Cb1zS4mM__"